

<!-- booker form - values stored in booker obj in addBooking -->
<form autocomplete="off" *ngIf="bookingAmendSection === 'booker' || bookingAmendSection === '' && priceLoaded" #form="ngForm" name="formBooker"
  class="" ng novalidate>

  <div class="panel panelPaymentOptionEmail">
    <div class="flex-always flex--space-between margin-bottom-16"
     [ngClass]="{ 'padding-top-16' : price.totalPrice.majorAmount === 0}">
      <h5 class="margin-top-0 margin-bottom-0 text-dark-blue">{{appCopy.panelHeader['yourDetailsTitle'+selectedLanguage]}}</h5>
      <a *ngIf="userLoggedIn && bookingType !== 'amend'" href="javascript:void(0);"
        (click)="logout()">{{appCopy.panelHeader['linkLogOut'+selectedLanguage]}}</a>
    </div>
    <div class="payment-login margin-bottom-16">
      <div class="form-group">
        <input class="form-control"
          [ngClass]="{ 'has-error' : bookerEmail.dirty && bookerEmail.invalid || bookerEmail.dirty && bookerEmail.errors?.pattern || bookerEmail.errors?.incorrect }"
          id="bookerEmail" name="bookerEmail" type="email" #bookerEmail="ngModel" [(ngModel)]="bookerData.emailAddress"
          [readonly]="userLoggedIn && (bookingType !== 'amend' || !user.userDetails.userPermissions.showAdminFeatures)"
          (blur)="verifiyAccount(bookerEmail.value)" (ngModelChange)="emailInputChangeHandler(bookerEmail.value)" (keyup)="resetValidationExpressCheckout()" autocomplete="off" required appCheckEmpty>
        <label class="control-label"
          for="bookerEmail">{{appCopy.panelHeader['bookerEmailLabel'+selectedLanguage]}}</label>
        <i class="icon control-validation-state"></i>

        <p class="help-block text-danger"
          *ngIf="bookerEmail.dirty && bookerEmail.invalid && !bookerEmail.errors?.pattern || bookerEmail.errors?.incorrect">
          {{appCopy.panelHeader['errorTextBookerEmailRequired'+selectedLanguage]}}</p>
        <p class="help-block text-danger" *ngIf="bookerEmail.dirty && bookerEmail.errors?.pattern">
          {{appCopy.panelHeader['errorTextBookerEmailInvalid'+selectedLanguage]}}</p>
      </div>
      <div *ngIf="!userLoggedIn && validEmail && !showLogin" class="form-group margin-bottom-0">
        <input
          class="form-control"
          type="text"
          name="bookerEmailConfirm"
          id="bookerEmailConfirm"
          [(ngModel)]="bookerData.emailAddressConfirm"
          #bookerEmailConfirm="ngModel"
          [ngClass]="{
            'has-error':
              bookerEmailConfirm.dirty &&
              bookerData.emailAddressConfirm?.trim().toLowerCase() !== bookerData.emailAddress?.trim().toLowerCase()
              || bookerEmailConfirm.errors?.incorrect
          }"
          (paste)="$event.preventDefault()"
          (drop)="$event.preventDefault()"
          (copy)="$event.preventDefault()"
          (cut)="$event.preventDefault()"
          (contextmenu)="$event.preventDefault()"
          autocomplete="new-password"
          required appCheckEmpty
        />

        <label class="control-label"
                  for="bookerEmail">{{appCopy.panelHeader['bookerEmailConfirmLabel'+selectedLanguage]}}</label>
                <i class="icon control-validation-state"></i>

        <p class="help-block text-danger"
          *ngIf="bookerEmailConfirm.dirty && bookerData.emailAddressConfirm?.trim().toLowerCase() !== bookerData.emailAddress?.trim().toLowerCase() || bookerEmailConfirm.errors?.incorrect">
          {{ appCopy.panelHeader['errorTextBookerEmailMatch' + selectedLanguage] }}
        </p>

      </div>

      <div class="reveal reveal--small">
        <div class="reveal__content">
          <div class="panel panel-default margin-bottom-0">
            <div class="panel-body">
              <div class="row">
                <p *ngIf="!loginWithOTP && !OTPLimitReached" class="col-lg-12 col-md-12 text-caption-large margin-bottom-8">
                  {{appCopy.panelHeader['welcomeBack'+selectedLanguage].replace('%s', userName)}}<br>
                </p>
                <p *ngIf="loginWithOTP && !OTPLimitReached" class="col-lg-12 col-md-12 margin-bottom-8 text-caption-large">{{appCopy.panelHeader['enterOtpLabel'+selectedLanguage]}}</p>
                <div *ngIf="!loginWithOTP && !OTPLimitReached" class="col-lg-6 col-md-6">
                  <div class="row">
                    <div class="col-sm-8">
                      <div class="form-group margin-bottom-0">
                        <div class="passwordIcon">
                          <input class="form-control"
                          [ngClass]="{ 'has-error' : loginPassword.invalid && loginPassword.dirty }" id="loginPassword"
                          name="loginPassword" [type]="showPassword.password ? 'text' : 'password'" #loginPassword="ngModel" ngModel alert-caps-lock
                          appCheckEmpty (keyup.enter)="inlineLogin(bookerEmail.value, loginPassword.value)">
                          <label class="control-label"
                          for="loginPassword">{{appCopy.panelHeader['loginPasswordLabel'+selectedLanguage]}}</label>
                          <div class="btntoggle" (click)="togglePasswordVisibility('password')">
                            <ng-container *ngIf="showPassword.password; else showPass">
                              <i class="icon-eye-blocked"></i>
                            </ng-container>
                            <ng-template #showPass>
                              <i class="icon-eye"></i>
                            </ng-template>
                          </div>
                        </div>
                        <i class="icon control-validation-state"></i>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <button  [ngClass]="{'Buttonloading' : showLoginLoader }" class="btn btn-primary btn-lg btn-block" type="button"
                        (click)="inlineLogin(bookerEmail.value, loginPassword.value)"
                        [disabled]="loginPassword.value === '' || showLoginLoader">
                        <!-- <div class="loader-container-btn" *ngIf="showLoginLoader">
                          <div class="loader loader--white">
                            <svg class="circular" viewBox="25 25 50 50">
                              <circle class="path" cx="50" cy="50" r="20" />
                            </svg>
                          </div>
                        </div> -->
                        <span *ngIf="!showLoginLoader">{{appCopy.panelHeader['buttonSubmit'+selectedLanguage]}}</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div *ngIf="loginWithOTP && !OTPLimitReached" class="col-lg-6 col-md-6">
                  <div class="row">
                    <div class="col-sm-8">
                      <div class="form-group margin-bottom-0">
                        <input class="form-control" type="text" [maxLength]="6"
                          [ngClass]="{ 'has-error' : otp.invalid && otp.dirty }" id="otp"
                          name="otp" #otp="ngModel" ngModel alert-caps-lock
                          appCheckEmpty (keyup.enter)="inlineOTPLogin(bookerEmail.value, otp.value)"
                          [pattern]="otpPattern" inputmode="numeric">
                        <label class="control-label"
                          for="otp">{{appCopy.panelHeader['OTPPlaceholder'+selectedLanguage]}}</label>
                        <i class="icon control-validation-state"></i>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <button  [ngClass]="{'Buttonloading' : showLoginLoader }" class="btn btn-primary btn-lg btn-block" type="button"
                        (click)="inlineOTPLogin(bookerEmail.value, otp.value)"
                        [disabled]="!otp || showLoginLoader || otp?.errors?.pattern">
                        <!-- <div class="loader-container-btn" *ngIf="showLoginLoader">
                          <div class="loader loader--white">
                            <svg class="circular" viewBox="25 25 50 50">
                              <circle class="path" cx="50" cy="50" r="20" />
                            </svg>
                          </div>
                        </div> -->
                        <span *ngIf="!showLoginLoader">{{appCopy.panelHeader['buttonSubmit'+selectedLanguage]}}</span>
                      </button>
                    </div>
                  </div>
                </div>

                <div *ngIf="!is2FARequired">
                  <div *ngIf="!loginWithOTP && !OTPLimitReached" style="height: 56px;" class="flex-always flex--align-center flex--justify-content-center col-lg-3 col-md-3">
                    <p [align]="'center'">{{appCopy.panelHeader['orText'+selectedLanguage]}}</p>
                  </div>
                  <div *ngIf="!loginWithOTP && !OTPLimitReached" class="col-lg-3 col-md-3">
                    <button [ngClass]="{'Buttonloading' : showOTPLoader }" class="btn btn-primary btn-lg btn-block" type="button"
                      (click)="sendOtp(bookerEmail.value)" [disabled]="showOTPLoader">
                      <span *ngIf="!showOTPLoader">{{appCopy.panelHeader['sendOTP'+selectedLanguage]}}</span>
                    </button>
                  </div>
                  </div>
                  <div *ngIf="loginWithOTP && !OTPLimitReached" class="col-lg-12 col-md-12">
                    <button (click)="sendOtp(bookerEmail.value)" class="btn btn-text-ghost" [disabled]="
                        isCounting || showOTPLoader ||
                        (bookerEmail.invalid && bookerEmail.dirty && !bookerEmail?.errors?.pattern)
                      ">
                      {{ isCounting ? appCopy.panelHeader['resendInSecText'+selectedLanguage].replace('%s', countdown) :
                      appCopy.panelHeader['resendOTPButton'+selectedLanguage] }}
                      <div *ngIf="showOTPLoader" class="loader-container-btn">
                        <div class="loader loader--gray">
                          <svg class="circular" viewBox="25 25 50 50">
                            <circle class="path" cx="50" cy="50" r="20" />
                          </svg>
                        </div>
                      </div>
                    </button>
                  </div>

                <div class="row col-lg-12 col-md-12 pr-0">
                  <div [ngClass]="{'col-lg-12': !loginWithOTP}"  class="col-lg-6 col-md-12">
                    <a href="javascript:void(0);" class="loginSkip-new" (click)="skiplogin()"
                    [appRevealToggle]="showLogin && !OTPLimitReached && !userLoggedIn ? 'open' : 'closed'">{{appCopy.panelHeader['skipAsGuestLabel'+selectedLanguage]}}</a>
                  </div>
                  <div *ngIf="loginWithOTP" class="col-lg-6 col-md-12 pr-0">
                    <a href="javascript:void(0);" class="loginSkip-new right" (click)="loginWithPassword()">{{appCopy.panelHeader['loginWithPasswordButton'+selectedLanguage]}}</a>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="reveal reveal--small">
      <div class="reveal__content">
        <div class="panel panel-default margin-bottom-0">
          <div class="panel-body">
            <div class="row">
              <div *ngIf="OTPLimitReached" class="col-lg-12 col-md-12 otp-limit-reached">
                <p class="text-danger">{{appCopy.panelHeader['OTPLimitReachMessage'+selectedLanguage]}}</p>
              </div>
                <div class="row col-lg-12 col-md-12 pr-0">
                  <div class="col-lg-6 col-md-12">
                      <a href="javascript:void(0);" class="loginSkip-new" (click)="skiplogin()"
                    [appRevealToggle]="OTPLimitReached && !userLoggedIn ? 'open' : 'closed'">{{appCopy.panelHeader['skipAsGuestLabel'+selectedLanguage]}}</a>
                  </div>
                  <div class="col-lg-6 col-md-12 pr-0">
                    <a href="javascript:void(0);" class="loginSkip-new right" (click)="loginWithPassword()">{{appCopy.panelHeader['loginWithPasswordButton'+selectedLanguage]}}</a>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div *ngIf="showOptOutMarketingEnrolment"
      class="checkbox checkbox--default checkbox--small checkbox--reverse margin-bottom-16">
      <input type="checkbox" name="optOutMarketingEnrolment" id="optOutMarketingEnrolment"
        #optOutMarketingEnrolment="ngModel" [ngModel]="false || (formData.set && (this.formData.data && this.formData.data.bookerForm.optOutMarketingEnrolment))">
      <label for="optOutMarketingEnrolment" style="color:#00005A;"
        class="text-caption">{{appCopy.panelHeader['optOutMarketingEnrolmentCheckLabel'+selectedLanguage]}}</label>
    </div> -->

  </div>

  <ng-container *ngIf="!showHasMarketingEnrolment">
    <div *ngIf="!customerOptIn" class="checkbox checkbox--default checkbox--small margin-top-0 margin-bottom-0 hasSmsMarketingEnrolment">
      <input type="checkbox" name="hasSmsMarketingEnrolment" id="hasSmsMarketingEnrolment"
        #HasSmsMarketingEnrolment="ngModel" [(ngModel)]="hasMarketingEnrolment" (ngModelChange)="trackMarketingOptInConsent($event)" >
      <label for="hasSmsMarketingEnrolment" class="text-caption">
        <span>
          <b>{{appCopy.panelHeader['hasSmsMarketingEnrolmentCheckLabel'+selectedLanguage]}}</b>
          <span>{{appCopy.panelHeader['hasSmsMarketingEnrolmentChecMsg'+selectedLanguage]}}</span>
        </span>
      </label>
    </div>
  </ng-container>

</div>

  <div class="panel paymentScreen padding-bottom-0 margin-bottom-0">
    <div class="row">
      <div class="col-xs-12">
        <div class="flex-always margin-bottom-8">
          <h5 class="text-dark-blue">{{appCopy.panelHeader['bookerPanelHeading'+selectedLanguage]}}</h5>
          <!-- <div class="bagtooltip margin-left-8">
            <span class="icon-span icon-span-small tooltip-trigger-text">
              <span class="icon-information icon-black icon_12">
              </span>
            </span>
            <span
              class="tooltiptext tooltip-top tooltip-passenger">{{appCopy.panelHeader['bookerFirstNameTooltipContent'+selectedLanguage]}}</span>
          </div> -->
        </div>
      </div>
      <div class="col-xs-12">
        <div class="form-group">
          <input class="form-control"
            [ngClass]="{ 'has-error' : bookerFirstName.dirty && bookerFirstName.invalid || bookerFirstName.errors?.incorrect }"
            id="bookerFirstName" name="bookerFirstName" type="text" #bookerFirstName="ngModel"
            [(ngModel)]="bookerData.firstName" [pattern]="letterPattern" required appCheckEmpty>
          <label class="control-label"
            for="bookerFirstName">{{appCopy.panelHeader['bookerFirstNameLabel'+selectedLanguage]}}</label>
          <i class="icon control-validation-state"></i>

          <p class="help-block text-danger" *ngIf="bookerFirstName.dirty && bookerFirstName.errors?.pattern">
            {{appCopy.panelHeader['errorTextBookerNameInvalid'+selectedLanguage]}}</p>
          <p class="help-block text-danger"
            *ngIf="bookerFirstName.dirty && bookerFirstName.invalid && !bookerFirstName.errors?.pattern && !bookerFirstName.errors?.incorrect">
            {{appCopy.panelHeader['errorTextBookerFirstNameRequires'+selectedLanguage]}}</p>
          <p class="help-block text-danger" *ngIf="bookerFirstName.errors?.incorrect">
            {{appCopy.panelHeader['errorTextBookerFirstNameRequires'+selectedLanguage]}}
          </p>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="form-group">
          <input class="form-control"
            [ngClass]="{ 'has-error' : bookerLastName.dirty && bookerLastName.invalid || bookerLastName.errors?.incorrect }"
            id="bookerLastName" name="bookerLastName" type="text" #bookerLastName="ngModel"
            [(ngModel)]="bookerData.lastName" [pattern]="letterPattern" required appCheckEmpty>
          <label class="control-label"
            for="bookerLastName">{{appCopy.panelHeader['bookerLastNameLabel'+selectedLanguage]}}</label>
          <i class="icon control-validation-state"></i>

          <p class="help-block text-danger" *ngIf="bookerLastName.dirty && bookerLastName.errors?.pattern">
            {{appCopy.panelHeader['errorTextBookerNameInvalid'+selectedLanguage]}}</p>
          <p class="help-block text-danger"
            *ngIf="bookerLastName.dirty && bookerLastName.invalid && !bookerLastName.errors?.pattern && !bookerLastName.errors?.incorrect">
            {{appCopy.panelHeader['errorTextBookerLastNameRequires'+selectedLanguage]}}</p>
          <p class="help-block text-danger" *ngIf="bookerLastName.errors?.incorrect">
            {{appCopy.panelHeader['errorTextBookerLastNameRequires'+selectedLanguage]}}</p>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="multiple-inputs clearfix flex margin-bottom-4">
          <div class="form-group with-select margin-bottom-0">
            <div class="with-select__custom-value">+{{contactCountryCode.value}}</div>
            <ng-select class="form-control form-control--no-label"
              [ngClass]="{ 'has-error' : contactPhone.errors?.incorrect || contactPhone.invalid && contactPhone.dirty }"
              id="contactCountryCode" name="contactCountryCode" #contactCountryCode="ngModel"
              [(ngModel)]="bookerData.countryCode" (ngModelChange)="validatePhoneNumber($event, contactPhone.value)"
              [clearable]="false"
              [items]="countryCodes.all" [notFoundText]="appCopy.panelHeader['bookerCountryNotFound'+selectedLanguage]" groupBy="label" bindLabel="displayText" bindValue="countryCode"
              >
            </ng-select>
          </div>
          <div class="form-group flex-1 margin-bottom-0">
            <input class="form-control form-control--no-label"
              [ngClass]="{ 'has-error' : contactPhone.invalid && contactPhone.dirty || contactPhone.errors?.incorrect }"
              type="tel" id="contactPhone" name="contactPhone" #contactPhone="ngModel"
              placeholder="{{appCopy.panelHeader['contactPlaceholder'+selectedLanguage]}}"
              [(ngModel)]="bookerData.phoneNumber"
              (blur)="validatePhoneNumber(contactCountryCode.value, contactPhone.value)" required appCheckEmpty>
            <i class="icon control-validation-state"></i>
          </div>
        </div>

        <p class="help-block text-danger"
          *ngIf="contactPhone.invalid && contactPhone.dirty || contactPhone.errors?.incorrect">
          {{appCopy.panelHeader['errorTextContact'+selectedLanguage]}}</p>

        <!-- <p class="text-caption-large margin-bottom-16 text-dark-blue">
          {{appCopy.panelHeader['contentContactNumber'+selectedLanguage]}}
        </p> -->
        <ng-container *ngIf="!showHasSmsWhatsAppEnrolment">
          <div *ngIf="!customerOptIn" class="checkbox checkbox--default checkbox--small margin-top-0 margin-bottom-16 hasSmsWhatsAppEnrolment">
            <input type="checkbox" name="hasSmsWhatsAppEnrolment" id="hasSmsWhatsAppEnrolment"
            #HasSmsWhatsAppEnrolment="ngModel" [(ngModel)]="hasSmsWhatsAppEnrolment" (ngModelChange)="trackSmsWhatsAppOptInConsent($event)" >
          <label for="hasSmsWhatsAppEnrolment" class="text-caption">
            <span>{{appCopy.panelHeader['hasSmsWhatsAppEnrolmentCheckLabel'+selectedLanguage]}}</span>
          </label>
        </div>
      </ng-container>
      </div>

      <div class="col-xs-12" *ngIf="showSetPassword">
        <div class="form-group fadeIn">
          <div class="passwordIcon">

            <input class="form-control" [ngClass]="{ 'has-error' : setPassword.dirty && setPassword.invalid }"
            id="setPassword" name="setPassword" [type]="showPassword.setNewPassword ? 'text' : 'password'" #setPassword="ngModel" [ngModel]='newUserSetPassword' alert-caps-lock
            appCheckEmpty (blur)="validatePassword(setPassword.value)">
            <label class="control-label"
            for="setPassword">{{appCopy.panelHeader['setPasswordLabel'+selectedLanguage]}}</label>
            <div class="btntoggle" (click)="togglePasswordVisibility('setNewPassword')">
              <ng-container *ngIf="showPassword.setNewPassword; else showPass">
                <i class="icon-eye-blocked"></i>
              </ng-container>
              <ng-template #showPass>
                <i class="icon-eye"></i>
              </ng-template>
            </div>
          </div>
          <i class="icon control-validation-state"></i>

          <p class="help-block text-danger" *ngIf="setPassword.dirty && setPassword.errors?.pattern">
            {{appCopy.panelHeader['errorTextSetPassword'+selectedLanguage]}}</p>
        </div>
      </div>
    </div>
  </div>
</form>
